import React from 'react';
var Line = function (_a) {
    var width = _a.width, height = _a.height, opacity = _a.opacity, fill = _a.fill;
    return (React.createElement("svg", { width: width, height: height, opacity: opacity, viewBox: "0 0 12 3" },
        React.createElement("line", { x1: "208", x2: "220", y1: "465.5", y2: "465.5", fill: "none", stroke: fill, strokeWidth: "3", transform: "translate(-208 -464)" })));
};
export default Line;
